import {
  Typography,
  Stack,
  Theme,
  useTheme
} from "@mui/material";
import { GetCurrentConsentApplicationBody } from "../../redux-store/actions/otpConsent";
import { BanksTable, NomineeTable } from "../commonComponents";
import { DISABLE_NOMINEE_OPY_OUT, NO_BANKS_ADDED, NO_NOMINEE_DISCLAIMER } from "../../utils/constant";
import { NomineeType, Bank } from "../../redux-store/types/api-types";

interface ConsentBankNomineeProps {
  currentApplicationData: Partial<GetCurrentConsentApplicationBody>;
}

function ConsentBankNominee({
  currentApplicationData
}: ConsentBankNomineeProps): JSX.Element {
  const theme = useTheme();

  return (
    <Stack spacing={1}>
      {/* Nominee Section */}
      {!DISABLE_NOMINEE_OPY_OUT && (((currentApplicationData?.nominees || []).length > 0) ? (
        <NomineeTable
          data={
            (currentApplicationData?.nominees ||
              []) as NomineeType[]
          }
        />
      ) : (
        <Typography
          color="text.secondary"
          sx={{ mt: 1, ...theme.typography.subtitle_400 }}
        >
          {NO_NOMINEE_DISCLAIMER}
        </Typography>
      ))}

      {/* Banks section */}
      {
        (((currentApplicationData?.banks || []).length > 0) ? (
          <BanksTable
            data={(currentApplicationData?.banks || []) as Bank[]}
          />
        ) : (
          <Typography
            color="text.secondary"
            sx={{ mt: 1, ...theme.typography.subtitle_400 }}
          >
            {NO_BANKS_ADDED}
          </Typography>
        ))
      }
    </Stack>
  );
}

export default ConsentBankNominee;
